export const TID = {
  // Login
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  loginToggleRegister: "login-toggle-register",
  registerName: "register-name-input",
  registerEmail: "register-email-input",
  registerPhone: "register-phone-input",
  registerPassword: "register-password-input",
  registerSubmit: "register-submit-button",
  authError: "auth-error",
  authSuccess: "auth-success",

  // Layout
  sidebar: "sidebar",
  navDashboard: "nav-dashboard",
  navLenders: "nav-lenders",
  navDeals: "nav-deals",
  navPricing: "nav-pricing",
  navAdmin: "nav-admin",
  navUsers: "nav-users",
  navAudit: "nav-audit",
  navLogout: "nav-logout",
  userBadge: "user-badge",

  // Dashboard
  dashboard: "dashboard",
  statTotalLenders: "stat-total-lenders",
  statActiveLenders: "stat-active-lenders",
  statPreferred: "stat-preferred-lenders",
  statTotalDeals: "stat-total-deals",
  statPending: "stat-pending-users",

  // Lenders
  lenderSearch: "lender-search-input",
  lenderFilterIndustry: "lender-filter-industry",
  lenderFilterState: "lender-filter-state",
  lenderFilterProduct: "lender-filter-product",
  lenderFilterStatus: "lender-filter-status",
  lenderAddBtn: "lender-add-button",
  lenderRow: (id) => `lender-row-${id}`,
  lenderEditBtn: "lender-edit-button",
  lenderDeleteBtn: "lender-delete-button",
  lenderFormSubmit: "lender-form-submit",
  noteText: "note-text-input",
  noteSubmit: "note-submit-button",

  // Pricing & recommendations
  dealForm: "deal-form",
  dealIndustry: "deal-industry-input",
  dealState: "deal-state-input",
  dealAmount: "deal-amount-input",
  dealTerm: "deal-term-input",
  dealRevenue: "deal-revenue-input",
  dealAdb: "deal-adb-input",
  dealNeg: "deal-neg-input",
  dealNsfs: "deal-nsfs-input",
  dealCredit: "deal-credit-input",
  dealTib: "deal-tib-input",
  dealProduct: "deal-product-input",
  dealRunRecommend: "deal-run-recommend",
  dealSave: "deal-save",
  bankUpload: "bank-upload-input",
  bankAnalyze: "bank-analyze-button",
  recRow: (id) => `rec-row-${id}`,

  // Admin
  approveUser: (id) => `approve-user-${id}`,
  disableUser: (id) => `disable-user-${id}`,
  roleSelect: (id) => `role-select-${id}`,
};

export default TID;
